import React from "react";
import styled from "styled-components";
import Theme from "../../../vars/ThemeOptions";

const Styled = {
  Curve: styled.svg`
    path {
      fill: ${Theme.hex("white")};
    }
    width: 100%;
    position: absolute;
    bottom: 0;
  `,
};

const CurveAI = () => {
  return (
    <Styled.Curve xmlns="http://www.w3.org/2000/svg" viewBox="0 0 622.3 31">
      <g>
        <path
          d="M311.15,0C188.66,0,78.17,11.91,0,31H622.3C544.13,11.91,433.64,0,311.15,0Z"
        />
      </g>
    </Styled.Curve>
  );
};

export default CurveAI;
